import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isInviteMembersRequestFailure() {
      return getState().request.isFailure;
    },
    isInviteMembersRequestPending() {
      return getState().request.isPending;
    },
    isInviteMembersRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getFailedMemberInvitations() {
      return getState().failedInvitations;
    },
  };
}

export { createSelector };
